// routes
import { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import { BaseOptionChartStyle } from './components/chart/BaseOptionChart';
import { CurrentModuleProvider } from './store/CurrentModuleContext';

// ----------------------------------------------------------------------

// Create a client
const queryClient = new QueryClient();

export default function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <DndProvider backend={HTML5Backend}>
          <CurrentModuleProvider>
            <Toaster
              containerStyle={{
                position: 'absolute',
                left: '80%',
              }}
            />
            <BaseOptionChartStyle />
            <Router />
          </CurrentModuleProvider>
        </DndProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
